import ssoConfig, { isSsoEnabled } from '@config/sso';
import { Button, Stack, TextInput } from '@mantine/core';
import { useForm, yupResolver } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { signsInWithSso } from '@services/auth';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { OtpRequestPayload } from '../../../../models/payload/auth';
import authSlice from '../../../../reducers/auth';
import { sendOtpForUser } from '../../../../reducers/otp';
import { AppDispatch, RootState } from '../../../../stores';
import PersianUtil from '../../../../utils/persianUtil';

interface ValuesType {
  phoneNumber: string;
}

const schema = Yup.object({
  phoneNumber: Yup.string()
    .matches(/^(0)9\d{9}$/, 'شماره وارد شده معتبر نیست.')
    .required('وارد کردن شماره تلفن همراه الزامی است.'),
});

const PhoneNumberDialogComponent = () => {
  const { loading } = useSelector((state: RootState) => state.otp);

  const dispatch: AppDispatch = useDispatch();

  // Asking whether this phone runs the store, and then on the way to the single sign-on.
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    dispatch(authSlice.actions.removeErrors());
  }, [dispatch]);

  const form = useForm<ValuesType>({
    initialValues: { phoneNumber: '' },
    validate: yupResolver(schema),
  });

  const onFormSubmit = form.onSubmit(async (values) => {
    const { phoneNumber } = values;

    // The store's owner and its staff sign in through the single sign-on, which takes them to the
    // store's panel. Only when this build names one; a customer goes on as before.
    if (isSsoEnabled()) {
      setChecking(true);
      if (await signsInWithSso(phoneNumber)) {
        notifications.show({
          id: 'staff-to-sso',
          message: 'این شماره به پنل فروشگاه دسترسی دارد؛ ورود از صفحه‌ی ورود یکپارچه انجام می‌شود.',
          color: 'blue',
        });
        // Handed to the SSO as login_hint, so the number is not typed twice.
        try {
          sessionStorage.setItem(ssoConfig.loginHintKey, phoneNumber);
        } catch (error) {
          // Storage closed to this page: the SSO then asks for the number again.
        }
        window.location.assign(ssoConfig.loginPath);
        return;
      }
      setChecking(false);
    }

    const otpData: OtpRequestPayload = { phoneNumber };

    dispatch(sendOtpForUser(otpData));
  });

  return (
    <form onSubmit={onFormSubmit}>
      <Stack>
        <TextInput
          label="شماره تلفن همراه"
          description="شماره با ۰۹ شروع می‌شود"
          placeholder="09121234567"
          {...form.getInputProps('phoneNumber')}
          onChange={(val) =>
            form
              .getInputProps('phoneNumber')
              .onChange(PersianUtil.toEnglishNumbers(val.target.value.split(' ').join('')))
          }
        />

        <Button type="submit" disabled={!form.isValid()} loading={loading || checking}>
          ادامه
        </Button>
      </Stack>
    </form>
  );
};

export default PhoneNumberDialogComponent;
